<!--! LOCKER GRID -->
<div class="animate__animated animate__fadeIn" style="display: inherit; height: 100%;">
	<app-locker-grid-admin
		[cStatus]="cStatus"
		[modulo]="modulo">
	</app-locker-grid-admin>
</div>
